"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSession = exports.withAuth = exports.redirectToAuthIfNecessary = exports.withSession = exports.getSessionData = exports.SessionContext = void 0;
const react_1 = __importStar(require("react"));
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const Cookies = __importStar(require("js-cookie"));
const sessionCookieName_1 = __importDefault(require("../utils/sessionCookieName"));
const useStorage_1 = require("./useStorage");
const getAppHostConfig_1 = __importDefault(require("../utils/getAppHostConfig"));
const ApiClient_1 = require("../utils/ApiClient");
const { WEB_HOST_AND_PORT } = getAppHostConfig_1.default();
exports.SessionContext = react_1.default.createContext(null);
// TODO: move this normalization logic along with whoAmI call into atms-web-service
exports.getSessionData = (whoAmIData, jwtCookie, jwtData) => {
    const { user: { id, firstName, lastName, userName, email, role, timezone, federateId, disableProjectSharing, accessSettings, machineTranslateSettingsDefaultId, }, organization, csrfToken, systemInfoMessage, availableProfiles, } = whoAmIData;
    // split out accessSettings into 1. the subjects we have access to and 2. flattened permissioms
    const access = Object.keys(accessSettings).reduce((memo, key) => {
        const setting = accessSettings[key];
        if (typeof setting === 'object') {
            const { client, businessUnits } = setting;
            memo[key] = { client, businessUnits };
        }
        return memo;
    }, {});
    const buildPermissions = (fromObj, permissions = [], prefix = '') => {
        Object.keys(fromObj).forEach(key => {
            if (fromObj[key] && typeof fromObj[key] === 'object' && key != 'client') {
                buildPermissions(fromObj[key], permissions, `${key}:`);
            }
            else if (fromObj[key] === true) {
                permissions.push(`${prefix}${key}`);
            }
        });
        return permissions;
    };
    const permissions = buildPermissions(accessSettings);
    return {
        user: {
            id,
            firstName,
            lastName,
            userName,
            email,
            role,
            timezone,
            federateId,
            disableProjectSharing,
            sysadminId: jwtData && jwtData['sysAdmin.userId'],
            machineTranslateSettingsDefaultId,
        },
        organization,
        csrfToken,
        systemInfoMessage,
        availableProfiles,
        access,
        permissions,
        loading: false,
        jwt: jwtCookie,
    };
};
exports.withSession = (Component) => {
    return props => {
        const jwtCookie = Cookies.get(sessionCookieName_1.default);
        const [cachedSession, setSession] = useStorage_1.useLocalStorage('session', { loading: true, jwt: null });
        let session = cachedSession;
        // if this is the first render but we have a cached non-AuthenticatedSession
        // (error, loading, or unauthenticated), discard it so that we try again.
        // this ensures we correctly do a whoAmI after the auth dance, error boundary
        // refreshes, other weirdness, etc.
        const isInitialRender = react_1.useRef(true);
        if (isInitialRender.current && !session.user) {
            session = { loading: true, jwt: null };
            setSession(session);
        }
        // (re)fetch from whoAmI whenever the cookie changes
        react_1.useEffect(() => {
            // jwt is current (or nonexistent), or we got an error previously, so we're good
            if (session.jwt === jwtCookie || session.error) {
                return;
            }
            isInitialRender.current = false;
            const jwtData = jsonwebtoken_1.default.decode(jwtCookie);
            if (!(jwtData === null || jwtData === void 0 ? void 0 : jwtData.userId)) {
                setSession({ loading: false, jwt: jwtCookie });
                return;
            }
            // indicate if we're logging in or the user has changed
            if (!session.user || session.user.id !== jwtData.userId) {
                setSession({ loading: true, jwt: jwtCookie });
            }
            (async function refreshSession() {
                var _a;
                try {
                    // Use the default client instead of AtmsApiClient to prevent ever going through CloudFront for auth
                    const whoAmIData = await ApiClient_1.DefaultClient.httpGet(`//${WEB_HOST_AND_PORT}/web/api/v3/auth/whoAmI?extended=true&rnd=` + Math.random(), jwtCookie ? { headers: { Authorization: `Bearer ${jwtCookie}` } } : {});
                    setSession(exports.getSessionData(whoAmIData, jwtCookie, jwtData));
                }
                catch (e) {
                    // set a session error in local state (will get cleared if we unmount)
                    setSession({
                        loading: false,
                        error: `Unable to retrieve your user profile. Error was: ${((_a = e.details) === null || _a === void 0 ? void 0 : _a.message) ||
                            e.message ||
                            e.toString()}`,
                    });
                }
            })();
        }, [jwtCookie, session, setSession]);
        return (react_1.default.createElement(exports.SessionContext.Provider, { value: session },
            react_1.default.createElement(Component, Object.assign({ session: session }, props))));
    };
};
// redirect for auth if necessary, but just once (since we might re-render this in rapid succcession)
let isRedirecting = false;
exports.redirectToAuthIfNecessary = (session) => {
    if (isRedirecting)
        return true; // subsequent render
    if (session.loading)
        return true; // wait and see...
    if ('user' in session)
        return false; // logged in
    isRedirecting = true;
    window.location.replace(`//${WEB_HOST_AND_PORT}/web/login/auth?backUrl=${encodeURIComponent(window.location.href)}`);
    return true;
};
exports.redirectToAuthIfNecessary.reset = () => (isRedirecting = false);
/**
 * HOC to ensure user is authenticated, will redirect if not
 */
exports.withAuth = (Component) => {
    return props => {
        const session = exports.useSession();
        // if we're loading the session or we've decided to redirect, render nothing
        if (exports.redirectToAuthIfNecessary(session)) {
            return null;
        }
        else {
            return react_1.default.createElement(Component, Object.assign({}, props));
        }
    };
};
/**
 * Hook to get the session from context. Depends on withSession being used above it in the component hierarchy.
 */
exports.useSession = () => {
    const session = react_1.useContext(exports.SessionContext);
    if (!session) {
        throw new Error('No session context provider found; you probably need to wrap your top-level component with withSession');
    }
    return session;
};
//# sourceMappingURL=useSession.js.map